import React, { useContext, useState } from 'react'
import { TemplatePage } from '../../../../../components/TemplatePage'
import { Image, KeyboardAvoidingView, Platform, ScrollView, Text, View } from 'react-native'
import { globalStyle } from '../../../../../theme/global'
import { StackNavigationProp } from '@react-navigation/stack'
import { LogisticsRoutes } from '../../../../../navigator/types'
import { useNavigation } from '@react-navigation/native'
import { GrayHeader } from '../../components/GrayHeader'
import { TextInputComponent } from '../../../../../components/TextInputComponent'
import { Button } from '../../../../../components/Button'
import { FuelContext } from '../../../../../context/Logistics/fuel/FuelProvider'
import { useForm } from '../../../../../hooks/useForm'
import { useTranslation } from 'react-i18next'
import { useKeyboardVisibility } from '../../../../../hooks/useKeyboardVisibility'
import { useMoveScroll } from '../../../../../hooks/useMoveScroll'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { textColor } from '../../../../../theme/colors'

interface Navigation extends StackNavigationProp<LogisticsRoutes, 'VoucherLog'> {}

export const VoucherLog = () => {
  const { handleValueNumber, form } = useContext(FuelContext)
  const { t } = useTranslation()
  const navigation = useNavigation<Navigation>()
  const { values, onChangeValues } = useForm({
    voucherNumber: '',
  })
  const [minLiters, setMinLiters] = useState(false)
  const { handleKeyboardPadding } = useKeyboardVisibility()
  const { scrollViewRef } = useMoveScroll({
    handleKeyboardPadding,
  })

  const handleNext = () => {
    handleValueNumber({ type: 'voucherNumber', value: +values.voucherNumber })
    navigation.navigate('Summary')
  }

  return (
    <TemplatePage
      header
      styleContent={{ padding: 0, marginBottom: 0 }}
      title={t('Recepción combustible')}
    >
      <KeyboardAvoidingView
        behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
        style={[globalStyle.viewContainer, { padding: 0 }]}
        keyboardVerticalOffset={50}
      >
        <ScrollView ref={scrollViewRef}>
          <GrayHeader title={t('Comprobante de entrega')} />

          <View style={{ padding: 24 }}>
            <Image
              source={{ uri: form.photos?.voucherPhoto?.uri }}
              resizeMode='cover'
              style={{ width: '100%', height: 350, borderRadius: 8 }}
            />
          </View>

          <View style={{ gap: 28, padding: 24, paddingTop: 0 }}>
            <TextInputComponent
              label={t('Ingrese el N° de folio del comprobante')}
              onChange={(value) => {
                if (Number(value) <= 0 && value !== '') {
                  setMinLiters(true)
                } else {
                  onChangeValues({ name: 'voucherNumber', value })
                }
              }}
              value={values.voucherNumber}
              keyboardType='numeric'
            />
            <View style={{ flexDirection: 'row', gap: 24, justifyContent: 'center' }}>
              <Button
                label={t('Repetir foto')}
                variant='white'
                onPress={() => navigation.replace('VoucherPhoto')}
              />
              <Button
                label={t('Continuar')}
                disabled={Number(values.voucherNumber) <= 0}
                onPress={handleNext}
              />
            </View>
          </View>

          {minLiters && (
            <AlertMessage action={() => setMinLiters(false)} title='Error'>
              <Text style={{ color: textColor }}>Ingrese un valor mayor que 0</Text>
            </AlertMessage>
          )}
        </ScrollView>
      </KeyboardAvoidingView>
    </TemplatePage>
  )
}
